import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=4d78cd41&scoped=true"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=4d78cd41&prod&scoped=true&lang=css"
import style1 from "./GameInfo.vue?vue&type=style&index=1&id=4d78cd41&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78cd41",
  null
  
)

export default component.exports